import React, { useState, useEffect } from "react";
import { 
    useLocation, 
    // useNavigate
} from "react-router-dom";
import {
    Box,
} from "@mui/material";
import { grey } from "@mui/material/colors";

import DashboardDrawer from "../components/DashboardDrawer";
import BottomNavigationMobile from "../components/BottomNavigation";
// import Footer from "../components/Footer";
import SearchAppBar from "../components/SearchAppBar";
import DefaultAppBar from "../components/DefaultAppBar";

// import { logoutUser } from "../services/authService";
import { searchProfiles } from "../services/searchService";

const DashboardLayout = ({ children, pageName }) => {
    const childName = children?.type?.name; // e.g., "SearcheResults" or "Dashboard"
    const location = useLocation();
    const [drawerOpen, setDrawerOpen] = useState(true);
    const [searchText, setSearchText] = useState("");
    const [searchLoading, setSearchLoading] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [totalResults, setTotalResults] = useState(0);
    const [searchTab, setSearchTab] = useState(0); // 0: AI Search, 1: Build your Search, 2: Persona Search
    
    useEffect(() => {
        // Only handle search logic for SearcheResults component, not MainSearch
        if (childName === "SearcheResults") {
            // Search logic
            const params = new URLSearchParams(location.search);
            const query = params.get("query") || "";
            const page = parseInt(params.get("page"), 10) || 1;
            const type = params.get("type") || "ai";
            setSearchText(query);
            if (query) {
                handleSearch(query, page);
            } else {
                setSearchResults([]);
                setTotalResults(0);
            }
        }
    }, [location.search, childName]);
    
    const handleSearch = async (searchText, page = 1) => {
        setSearchLoading(true);
        try {
            const result = await searchProfiles(searchText, page);
            setSearchResults(result?.data || result || []);
            setTotalResults(result?.totalResults ? parseInt(result.totalResults, 10) : 0);
        } catch (e) {
            setSearchResults([]);
            setTotalResults(0);
        } finally {
            setSearchLoading(false);
        }
    };

    // Set drawer width to match your DashboardDrawer
    const drawerWidth = drawerOpen ? 200 : 80;

    return (
        <Box sx={{ display: "flex", height: "100vh" }}>
            {/* Dashboard Drawer */}
            <DashboardDrawer open={drawerOpen} onToggle={() => setDrawerOpen((v) => !v)} />
            {/* Dashboard Drawer */}
    
            <Box sx={{ flex: 1, display: "flex", flexDirection: "column", ml: { xs: 0, md: `${drawerWidth}px` }, transition: "margin-left 0.2s" }}>
                {/* AppBar Starts */}
                {pageName === "Search" ? (
                    <SearchAppBar searchTab={searchTab} query={searchText} setSearchTab={setSearchTab} />
                ) : (
                    <DefaultAppBar searchText={searchText} />
                )}
                { /* AppBar Ends */}

                {/* Display Area Starts */}
                <Box 
                    justifyContent="center" 
                    alignItems="center" 
                    paddingX={2} 
                    paddingY={1} 
                    sx={{ 
                        flex: 1, 
                        bgcolor: grey[50], 
                        marginY: 1, 
                        marginX: 1, 
                        boxShadow: 2,
                        overflowY: 'auto', // Allow scrolling if content is too long
                    }}
                >
                {childName === "SearcheResults" && children
                    ? React.cloneElement(children, {
                        searchText,
                        searchLoading,
                        searchResults,
                        totalResults,
                        handleSearch,
                        location
                    })
                    : children}
                    </Box>
                {/* Display Area Ends */}
                {/* <Footer /> */}
            </Box>
            
            {/* Bottom Navigation for Mobile */}
            {/* <BottomNavigationMobile /> */}
        </Box>
    );
};

export default DashboardLayout;